// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4952":"c5bd093fe659bc04","6394":"d983d0c6c5bbed75","9910":"d132dcbb82d67468"}[chunkId] + ".css";
};